import React, { useEffect, useState } from 'react'

import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks'
import { WalletActionButton } from '@tronweb3/tronwallet-adapter-react-ui'

import tronLogo from '@src/assets/chains/tron.svg'

const TronWalletButton = (props: React.ComponentProps<typeof WalletActionButton>) => {
    const { wallet, connected, address } = useWallet()
    const [buttonText, setButtonText] = useState('Tron')

    useEffect(() => {
        if (connected && wallet) {
            if (address) {
                const shortAddress = `${address.slice(0, 4)}...${address.slice(-4)}`
                setButtonText(shortAddress)
            } else {
                setButtonText(wallet.adapter.name)
            }
        } else {
            setButtonText('Tron')
        }
    }, [wallet, connected, address])

    return (
        <div className='relative'>
            <WalletActionButton
                {...props}
                icon={tronLogo}
                className='tron-wallet-button custom-wallet-button w-7 rounded-2xl'
            >
                {buttonText}
            </WalletActionButton>
        </div>
    )
}

export default TronWalletButton
